"use client";
import axios from "@/lib/axios";
import { apis } from "@/static/apis/apis";
import { Axios } from "axios";
import { Dispatch, SetStateAction } from "react";
export const putNotifSeen = async (
//   data: {
//   },
  axiosAuth: Axios,
  id: number,
  // setData:Dispatch<SetStateAction<any[]>>
) => {
  try {
    let val = await axiosAuth.put(apis.notification.seen(id));
    // setData(val.data)
    return val;
  } catch (error: any) {
    console.error("Error Puting data:", error.message);
    return undefined;
  }
};
